import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from './entity';

@JsonObject('ClientFilter')
export class ClientFilter extends Entity {
  @JsonProperty('name', [String])
  public name?: [string] = undefined;
  @JsonProperty('serialNumber', [String])
  public serialNumber?: [string] = undefined;
  @JsonProperty('location', [String])
  public location?: [string] = undefined;
  @JsonProperty('type', [String])
  public type?: [string] = undefined;
  // @JsonProperty('order_by', [String])
  // public orderBy?: [String] = undefined;
  // @JsonProperty('direction', [String])
  // public direction?: [String] = undefined;
}
